__webpack_require__.p = "https://ux-pool-staging.azurewebsites.net/";